import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Checkout from './checkout';

class App extends React.Component {

    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/:store/:handle" component={Checkout}/>
                </Switch>
            </Router>
        )
    }
}

const mapStateToProps = state => {
    return state;
}
  
export default connect(
    mapStateToProps
)(App);